import { motion } from "framer-motion";
import { MaskedLine } from "./motion";

export default function PageHero({ eyebrow, title, highlight, subtitle, image }) {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid="page-hero">
      <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-skycyan/20 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-96 w-96 rounded-full bg-mint/20 blur-3xl" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 sm:px-8 md:px-12 lg:grid-cols-2 lg:py-28">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-xs font-bold uppercase tracking-[0.25em] text-mint"
            data-testid="page-hero-eyebrow"
          >
            {eyebrow}
          </motion.p>
          <h1 className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="page-hero-title">
            <MaskedLine delay={0.1}>{title}</MaskedLine>
            {highlight && (
              <MaskedLine delay={0.25}>
                <span className="text-mint">{highlight}</span>
              </MaskedLine>
            )}
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.45 }}
            className="mt-6 max-w-lg text-base leading-relaxed text-white/70 md:text-lg"
            data-testid="page-hero-subtitle"
          >
            {subtitle}
          </motion.p>
        </div>
        {image && (
          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="overflow-hidden rounded-[2rem] border border-white/10 shadow-lift">
              <img src={image} alt={title} width="1280" height="853" decoding="async" className="aspect-[4/3] w-full object-cover" data-testid="page-hero-image" />
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
